/**
 * Order status
 */
export const OrderStatus = {
  // The order has been initialized (stored in the database)
  Initialized: 'initialized',
  // Payment for the order has been initiated
  Paying: 'paying',
  // Payment for the order has been received and the order is now completed
  Completed: 'completed',
  // The order has been cancelled
  Cancelled: 'cancelled'
}
